import { configureStore } from '@reduxjs/toolkit'
import { userSlice } from './slices/userSlice'
import languageReducer from './slices/languageSlice'
import modalSlice from './slices/modalSlice'
import walletSlice from './slices/walletSlice'
import userPublicSlice from './slices/userPublicSlice'
import levelSlice from './slices/levelSlice'
import missionsReducer from './slices/missionsSlice'
import jackpotReducer from './slices/jackpotSlice'
import tournamentsRed from './slices/tournamentListSlice'
import tournamentDetailsSlice from './slices/tournamentDetailesSlice'
import minigamesSlice from './slices/miniGamesSlice'
import badgesSlice from './slices/badgesSlice'
import burgerSlice from './slices/burgerMenuSlice'
import inboxSlice from './slices/inboxSlice'
import storeSlice from './slices/storeSlice'
import gameReducer from './slices/gameSlice'
import sportsReducer from './slices/sportsSlice'
import { reInitDataForLanguage } from './initThunks'

export const store = configureStore({
	reducer: {
		user: userSlice.reducer,
		language: languageReducer,
		modal: modalSlice,
		wallet: walletSlice,
		userPublic: userPublicSlice,
		level: levelSlice,
		missions: missionsReducer,
		badges: badgesSlice,
		jackpot: jackpotReducer,
		tournaments: tournamentsRed,
		tournamentInfo: tournamentDetailsSlice,
		minigames: minigamesSlice,
		burger: burgerSlice,
		inbox: inboxSlice,
		store: storeSlice,
		game: gameReducer,
		sports: sportsReducer,
	},
})

const initializeStore = () => {
	store.dispatch(reInitDataForLanguage('en')) 
}

initializeStore()

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
